import { fromEvent, pipe } from 'rxjs'
import { filter, map, tap } from 'rxjs/operators'

const xSENSIBILITY = 30
const ySENSIBILITY = 20

const touchStart = {
  init({ el, vnode }) {
    fromEvent(el, 'touchstart')
      .pipe(
        filter(touchStart.filter),
        tap(touchStart.setPositions)
      )
      .subscribe()

    return { el, vnode }
  },
  setPositions($event) {
    swipeMenu.xPosition = $event.touches[0].clientX
    swipeMenu.yPosition = $event.touches[0].clientY
    return { xPosition: swipeMenu.xPosition, yPosition: swipeMenu.yPosition }
  },
  filter: $event => $event.touches.length,
}

const touchMove = {
  init({ el, vnode }) {
    fromEvent(el, 'touchmove')
      .pipe(
        filter(touchMove.filterXposition),
        map(touchMove.getPositions),
        filter(touchMove.filterYposition),
        tap(touchMove.emitMenuEvent(vnode))
      )
      .subscribe()
    return { el, vnode }
  },
  filterXposition: $event => swipeMenu.xPosition && $event.touches.length,
  filterYposition: ({ clientY }) => {
    const yDiff = swipeMenu.yPosition - clientY
    return yDiff < ySENSIBILITY && yDiff > ySENSIBILITY * -1
  },
  getPositions: $event => ({
    clientY: $event.touches[0].clientY,
    clientX: $event.touches[0].clientX,
  }),
  emitMenuEvent(vnode) {
    return ({ clientX }) => {
      const swipein20PercentOfWindow = (clientX * 100) / window.innerWidth < 21
      const xDiff = swipeMenu.xPosition - clientX

      if (xDiff > xSENSIBILITY) {
        vnode.context.$root.$emit('menu::close')
      } else if (xDiff < xSENSIBILITY * -1 && swipein20PercentOfWindow) {
        vnode.context.$root.$emit('menu::open')
      }
    }
  },
}

const swipeMenu = {
  bind(el, _, vnode) {
    const pipeOfFunctions = pipe(
      touchStart.init,
      touchMove.init
    )
    pipeOfFunctions({ el, vnode })
  },
  touchMove,
  touchStart,
  xPosition: undefined,
  yPosition: undefined,
}

export default swipeMenu
